import React from 'react'
import { useSelector } from 'react-redux';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import { FullPageLoading } from '../components/utils/Loading';
import { RootState } from '../store';
import { resolvePostLoginPath } from '../utils/authReturnUrl';

function PublicOnlyRoute({ children  } : any) {
  const accessToken = useSelector((state : RootState) => state.session.accessToken); 
  const loading = useSelector((state : RootState) => state.session.loading);
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const fromLocation = (location.state as any)?.from;
  const redirectPath = resolvePostLoginPath({ searchParams, from: fromLocation });

  if (!accessToken && !loading) {
      return children;
  } else if (loading) {
      return <FullPageLoading />;
  } else if (accessToken && !loading) {
    return <Navigate to={redirectPath} state={{from: location}} replace/>;
  } else {
      return <p>Something went wrong</p>;
  }
}

export default PublicOnlyRoute